import script from "./GenerateResult.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateResult.vue?vue&type=script&setup=true&lang=js"

import "./GenerateResult.vue?vue&type=style&index=0&id=2dc46bf1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc46bf1"]])

export default __exports__